"use client";

import { PostFeed } from "./_modules/components/PostFeed";
import { StickyRail } from "./_modules/components/StickyRail";
import { CategoryRail } from "./_modules/components/ForumChrome";
import { ForumHero } from "./_modules/components/ForumHero";

export default function ForumHomePage() {
  return (
    <div>
      <ForumHero />
      <div className="flex gap-6">
        <aside className="hidden w-52 shrink-0 lg:block">
          <StickyRail>
            <p className="px-2 pb-2 font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">Rooms</p>
            <CategoryRail activeSlug={null} />
          </StickyRail>
        </aside>
        <main className="min-w-0 flex-1">
          <PostFeed />
        </main>
      </div>
    </div>
  );
}
